import {ordermainUrls, ordermain} from './ordermain'

export const orderUrls = [
  ...ordermainUrls
]

export const order = {
  ordermain
}



// WEBPACK FOOTER //
// ./src/api/gip/order/index.js